import React from 'react';
import Joi from 'joi';

import Form from '../common/form';
import Progress from '../themed/progress';
import SignaturePreview from '../themed/signature-pad/preview';

import * as models from '../../utils/models';
import * as utils from '../../utils/utilities';

import * as authService from '../../services/authService';
import * as constants from '../../utils/constants';
import * as service from '../../services/reportService';
import * as toastService from '../../services/toastService';

import routes from '../../utils/routes';
import _ from 'lodash';

class ClientReviewForm extends Form {
	state = {
		data: { customerReviewStatus: '', reviewComment: '', reviewCommentDocumentUrl: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		customerReviewStatus: Joi.string().required().label('Review Status'),
		reviewComment: Joi.string().min(7).required().label('Comments'),
		reviewCommentDocumentUrl: Joi.array().min(0).max(1).required().label('Comment Document File'),
	};

	getApiData = () => {
		const pdf: any = _.omit(this.state.data, ['reviewCommentDocumentUrl']);

		if (this.state.data.reviewCommentDocumentUrl.length > 0) {
			pdf.reviewCommentDocumentUrl = (this.state.data.reviewCommentDocumentUrl[0] as models.PDFImageProps).src;
		}

		return pdf;
	};

	postData = async (): Promise<void> => {
		const project: models.Project = this.props.project;
		if (!project) return toastService.error('Project not available!');

		await service.clientReview(project.report._id, this.getApiData(), this.handleProgressChange);

		window.location.href = routes.organizationDashboard.fullPath;
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Submitting Review',
			success: 'Review Submitted',
			error: utils.getErrorMessage,
		});
	};

	render() {
		const user = authService.getCurrentUser() as models.User;

		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit} className="p-3">
					<h3 className="form-title">Review Report </h3>

					{this.renderSelect({
						name: 'customerReviewStatus',
						label: 'Review Status',
						placeholder: 'Do you approve this report?',
						options: REVIEW_OPTIONS,
					})}

					{this.renderTextArea({
						name: 'reviewComment',
						label: 'Comments',
						rows: '4',
						placeholder: 'Enter Your Comments',
					})}

					<div className="bg-light border mt-2 p-2">
						{this.renderFileInput({
							max: constants.IMAGE_LIMITS.EXCEL_ISO_UPLOAD,
							multiple: constants.IMAGE_LIMITS.EXCEL_ISO_UPLOAD > 1,
							name: 'reviewCommentDocumentUrl',
							accept: constants.EXCEL_APPLICATION_TYPE + ',' + constants.PDF_APPLICATION_TYPE,
							label: 'Comment Document (PDF/Excel File)',
							sublabel: 'Upload Comment Document',
							types: [constants.EXCEL_APPLICATION_TYPE, constants.PDF_APPLICATION_TYPE],
						})}
					</div>

					{user.signature && <SignaturePreview signatureUrl={user.signature} />}

					<div className="d-flex justify-content-end">
						{this.renderButton('Submit Review')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

const REVIEW_OPTIONS = [
	{
		id: 'approved',
		name: 'I approve',
	},
	{
		id: 'rejected',
		name: 'I do not approve',
	},
]

export default ClientReviewForm;
